import { getAsync as _getAsync } from "../../api";
import { dateToString } from "utils/dateUtils";

const BASE_URL = "/pos/entries/reports";

function normalizeMasterData(data) {
    const { date: dateInMillis } = data;

    const date = new Date(dateInMillis);

    return {
        ...data,
        date,
        dateString: dateToString(date, false),
    };
}

function normalizeData(data) {
    return data.map(normalizeMasterData);
}

export async function getSalesByDateRangeAsync(initialDate, finalDate) {
    return _getAsync({ url: `${BASE_URL}/sales`, data: { initialDate, finalDate } });
}

export async function getSalesByDateRangePerUsersAsync(initialDate, finalDate) {
    return _getAsync({ url: `${BASE_URL}/sales:withUsers`, data: { initialDate, finalDate }, normalizer: normalizeData });
}
